export default function RouletteRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 810px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>

                                <div>
                                    <center>
                                        <h1><b>Auto Roulette</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20"> To predict the number on which the ball will land. Ball is spun within the Roulette wheel. </p>
                                        </div>
                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"> Number wins: If the ball comes to rest on that number </p>
                                            <div>
                                                <div>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/roulette-rules.jpg" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Bets</th>
                                                                <th>Description</th>
                                                                <th>Payout</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <th>Straight up</th>
                                                                <th>Place chip on any single number (including 0)</th>
                                                                <th>1 to 35</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Split Bet</th>
                                                                <th>Place chip on the line (vertical/Horizontal) between 2 numbers.</th>
                                                                <th>1 to 17</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Street Bet</th>
                                                                <th>Place chip at end of a row. Covers 3 numbers</th>
                                                                <th>1 to 11</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Corner Bet</th>
                                                                <th>Place chip at corner (intersection of 4 numbers)</th>
                                                                <th>1 to 8</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Line Bet</th>
                                                                <th>Place chip at intersection of 2 rows (Covers 6 numbers)</th>
                                                                <th>1 to 5</th>
                                                            </tr>

                                                            <tr>
                                                                <th>Column Bet</th>
                                                                <th>Place chip at end of column on the boxes marked 2 to 1. (Covers 12 numbers)</th>
                                                                <th>1 to 2</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Dozen Bet</th>
                                                                <th>Place chip at on the boxes marked “1st 12”, “2nd 12”, “3rd 12”. (Covers 12 numbers)</th>
                                                                <th>1 to 2</th>
                                                            </tr>

                                                            <tr>
                                                                <th>Red/Black</th>
                                                                <th>Place chip at on the boxes marked “Red”, “Black”. (Covers 18 numbers)</th>
                                                                <th>1 to 1</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Even/Odd</th>
                                                                <th>Place chip at on the boxes marked “Even”, “Odd”. (Covers 18 numbers)</th>
                                                                <th>1 to 1</th>
                                                            </tr>
                                                            <tr>
                                                                <th>1-18/19-36</th>
                                                                <th>Place chip at on the boxes marked “1-18”, “19-36”. (Covers 18 numbers)</th>
                                                                <th>1 to 1</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </center>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}